import type { ToolsTranslations } from "../../types/tools";

export const tools: ToolsTranslations = {
  title: "Tools",
  subtitle: "Franklin internal tools",
  drawingCompare: {
    navLabel: "Drawings",
    description:
      "View DWG drawings in their original colors, and compare versions to see exactly what changed.",
    selectProject: "Project",
    stopCompare: "Stop comparing",
    applySelection: "Apply",
    compareDifferences: "Compare differences",
    selectTwoDrawings: "Select exactly two drawings to compare",
    drawingsCountSuffix: "drawings",
    compareOlder: "Older",
    compareNewer: "Newer",
    compareSwap: "Swap older / newer",
    showVersions: "Show older versions",
    hideVersions: "Hide older versions",
    noProjects: "No projects available.",
    noDrawings: "No DWG drawings in this project yet.",
    loadingDrawings: "Loading drawings…",
    drawingsLoadFailed: "Couldn't load drawings — retry",
    chooseDrawing: "Choose drawing…",
    browseAllDrawings: "Browse all {count} DWG files",
    sectionSelected: "Selected",
    sectionRecent: "Recent",
    sectionLatestUploads: "Latest uploads",
    browseDrawingsTitle: "Browse drawings",
    comparing: "Comparing…",
    preparingDrawing: "Preparing drawing…",
    samePairError:
      "Both sides are the same drawing version — pick two different versions to compare.",
    modeOverlay: "Overlay",
    modeSide: "Side by side",
    modeHighlight: "Changes only",
    modeSwipe: "Swipe",
    modeBlink: "Blink",
    toolRuler: "Ruler",
    toolArea: "Area",
    toolCoordinate: "Coordinate",
    createIssue: "Create issue",
    createIssueHint: "Click the drawing where the issue belongs — Esc cancels",
    showIssues: "Show issues",
    hideIssues: "Hide issues",
    issueMarkerLabel: "Open issue #{n}",
    issueLoadFailed: "The issue could not be loaded.",
    fit: "Fit",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    downloadScreenshot: "Download screenshot",
    showControls: "Show controls",
    hideControls: "Hide controls",
    layers: "Layers",
    layersAll: "All",
    layersChanged: "Changed only",
    legendAdded: "Added",
    legendRemoved: "Removed",
    legendUnchanged: "Unchanged",
    legendRedrawn: "Redrawn rows",
    legendRedrawnHint:
      "Removed or added entities whose ink the other revision still draws in the same place, colour, weight and dash. They change nothing on the page, so they are left out of the counts above.",
    legendRedrawnSplit:
      "{a} in the older revision, {b} in the newer. One entity can be redrawn as several, so the two sides need not match and the total counts rows, not objects.",
    legendRedrawnAtLeast:
      "This comparison reported the cancelled rows of one revision only, so at least this many were cancelled — the other revision's count is unknown.",
    bgDark: "Dark",
    bgLight: "Light",
    exportPdf: "Export PDF",
    exportTitle: "PDF export",
    exportAccept: "Download PDF",
    exportCancel: "Cancel",
    exportDrawWindow: "Draw a window",
    exportDrawAgain: "Draw it again",
    exportWholeDrawing: "Whole drawing",
    exportPickHint: "Click the two corners of the window — Esc cancels",
    viewerEngineFailed: "The drawing viewer engine failed to load. Refresh the page and try again.",
    placeholder: "Choose a drawing to view it — stage a second one to compare the two.",
    invalidIds: "The drawing viewer needs 1 or 2 document ids.",
    seedNotFound: "A requested drawing could not be found.",
    loading: "Loading drawing…",
    accuracyNotice:
      "Visual preview only. Some elements may differ from the original. Refer to the source DWG for detailed review and validation.",
  },
};
